import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

type CreateCommunityChannelProps = {
  squad: object;
  adminId: string;
  communityChannelName?: string;
};

export const useCreateCommunityChannel = () => {
  return useMutation(
    [`useCreateCommunityChannel`],
    ({ squad, adminId, communityChannelName }: CreateCommunityChannelProps) =>
      apiFetch(null, `internal/expert-management/community-channel`, {
        method: 'POST',
        body: {
          squad,
          adminId,
          communityChannelName,
        },
      }),
  );
};
